@if (enable() && allowSwitch()){
  <div [class.map-control-button-container]="(isMobileLayoutEnabled$ | async) === false">
    <button mat-flat-button
            class="map-control-button toggle-button"
            [tmTooltip]="tooltip()"
            (click)="toggle()">
      <mat-icon svgIcon="tools_3d"></mat-icon>
    </button>
  </div>
}
